import styles from './FJMenuTab.module.less';
import { useMemo, memo } from 'react';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import useLocalStore from '../../../hooks/useLocalStore.js';
import FJTextWithEllipsis from '../FJTextWithEllipsis/FJTextWithEllipsis.jsx';

function FJMenuTab(props) {
    useLocalStore();
    const {
        list = [],
        curIndex = 0,
        onChange,
        className,
        style,
        bgBoxClassName,
        bgInnerClassName,
        textClassName,
        tabClassName,
        activeClassName,
    } = props;

    const left = useMemo(() => {
        return curIndex * (100 / list.length) + '%';
    }, [curIndex, list.length]);

    return (
        <div className={classNames(styles.box, className)} style={style}>
            <div
                className={classNames(styles.bk, bgBoxClassName)}
                style={{ left: left, width: 100 / (list.length || 2) + '%' }}
            >
                <div className={classNames(styles.inner, bgInnerClassName)} />
            </div>
            <ul className={classNames(styles.tab, tabClassName)}>
                {list.map((item, index) => {
                    return (
                        <li
                            key={index}
                            onClick={() => {
                                onChange(index);
                            }}
                            className={classNames(
                                index === curIndex ? activeClassName : '',
                                index === curIndex ? styles.active : '',
                            )}
                        >
                            <FJTextWithEllipsis
                                className={classNames(styles.text, textClassName)}
                                text={FJLocalStore._(item.text)}
                            />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default memo(FJMenuTab);
